<mat-form-field>
  <mat-label>{{'Country' | translate}} </mat-label>
  <mat-select [value] = "selectedCountryId"
    (selectionChange)="countryChanged($event)"
    id="country"
    [placeholder]="'Country' | translate"
    (openedChange)="onOpenedChanged($event)">
    @for (s of countries; track s) {
      <mat-option [value]="s.id">
        {{ s.countryName }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
